import { Modal } from 'components/Modal/Modal';
import { GraniteButton } from 'components/V2/Button/GraniteButton';
import React from 'react';
import { useNavigate } from 'react-router-dom';

const DiscardProgressModal = ({
  isOpen,
  close,
}: {
  isOpen: boolean;
  close: () => void;
}) => {
  const navigate = useNavigate();
  return (
    <Modal isVisible={isOpen} close={close} className="max-w-[624px]">
      <div className="flex w-full flex-col items-start justify-start rounded-[8px] bg-background-base-surface-2 p-8">
        <div className="mb-8 flex flex-col items-start justify-start gap-2">
          <h1 className="text-2xl font-bold text-content-base-default">
            Discard progress?
          </h1>
          <p className="text-base font-bold text-content-base-subdued">
            Are you sure you want to discard your progress? If you proceed, all
            changes will be lost and cannot be recovered.
          </p>
        </div>
        <div className="flex items-start justify-start gap-4">
          <GraniteButton size="large" variant="secondary" onClick={close}>
            Cancel
          </GraniteButton>
          <GraniteButton
            size="large"
            variant="destructive"
            onClick={() => navigate('/access-express/index')}
          >
            Yes, discard progress
          </GraniteButton>
        </div>
      </div>
    </Modal>
  );
};

export default DiscardProgressModal;
